import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { datadogRum } from '@datadog/browser-rum';
import { SocietyDto } from '../graphql/results';

export type Society = Partial<SocietyDto> & {
  loading: boolean;
  orgId: string;
  /**
   * Set by the society layout when the URL's societyCode cannot be resolved to
   * a real society. Used by `useIsPublicSearch` to fall back to the generic
   * site header (instead of rendering the society-scoped header with its
   * perpetual loading skeleton).
   */
  notFound?: boolean;
};

type PublicSearchContextStore = {
  society: Society;
  setSociety: (society: Society) => void;
};

const usePublicSearchContext = create<PublicSearchContextStore>()(
  persist(
    devtools(
      immer((set) => ({
        society: { loading: true, orgId: '' },
        setSociety: (society) =>
          set(() => ({
            society,
          })),
      })),
      { name: 'PublicSearchContextStore' },
    ),
    {
      name: 'PublicSearchContextStore',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

usePublicSearchContext.subscribe((state) => {
  const { society } = state;
  if (society?.societyCode) {
    datadogRum.setGlobalContextProperty('society_code', society.societyCode);
    datadogRum.setGlobalContextProperty('society_id', society.societyId);
    datadogRum.setGlobalContextProperty('org_id', society.orgId);
  }
});

export default usePublicSearchContext;
